__webpack_require__.p = "/yi-insight/";